<template>
  <div>
    <div class="space-y-10">
      <CatalogFilterItem
        v-for="filterItem in localFilters"
        :key="filterItem.id"
        v-model="valueLocal[getValueKey(filterItem)]"
        :disabled="disabled"
        :item="filterItem"
      />
    </div>

    <button
      v-if="shouldCollapsed && isCollapsed"
      class="title mt-6 text-sm uppercase tracking-[0.12em] text-blue"
      @click="toggleCollapse"
    >
      {{ $t('show_more') }} ({{ collapsedCount }})
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import CatalogFilterItem from '@/domains/catalog/components/CatalogFilterItem.vue';

const MAX_ITEMS = 5;

interface Props {
  filters?: any[];
  modelValue?: any;
  disabled?: boolean;
}
interface Emits {
  (e: 'update:modelValue', data: Props['modelValue']): void;
}

const props = withDefaults(defineProps<Props>(), {
  filters: () => [],
  modelValue: () => ({}),
  disabled: false,
});

const emit = defineEmits<Emits>();

const isCollapsed = ref(true);

const valueLocal = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    if (!props.disabled) emit('update:modelValue', newValue);
  },
});

const shouldCollapsed = computed(() => props.filters.length > MAX_ITEMS);
const localFilters = computed(() => {
  if (shouldCollapsed.value && isCollapsed.value)
    return props.filters.slice(0, MAX_ITEMS);
  return props.filters;
});
const collapsedCount = computed(() => props.filters.length - MAX_ITEMS);

const isFeatureFilter = (filter: any) => {
  return typeof filter.id !== 'string';
};

const getValueKey = (filter: any) =>
  isFeatureFilter(filter) ? 'filters' : filter.id;

const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value;
};
</script>
